import React from 'react';
// import { urlRegexExact } from '../../extensions/extension-link/link';

const Toolbar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <div>
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={editor.isActive('bold') ? 'is-active' : ''}
        type="button"
      >
        bold
      </button>
      <button
        onClick={() => {
          editor
            .chain()
            .focus()
            .setImageLoading(true)
            .setImageUrl('8bb438_1da83d5d8fcd481ba6bf60b40db869c6.jpg') // base 64 image
            .run();
          setTimeout(() => {
            editor
              .chain()
              .focus()
              .silent()
              .setImageLoading(false)
              .setImageUrl('8bb438_8583414cdf6544a191e2b8f678ce7b63.jpg')
              .run();
          }, 5000);
        }}
        className={editor.isActive('bold') ? 'is-active' : ''}
        type="button"
      >
        change image
      </button>

      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={editor.isActive('italic') ? 'is-active' : ''}
        type="button"
      >
        italic
      </button>
      <button
        onClick={() => editor.chain().undoable().focus().toggleItalic().run()}
        className={editor.isActive('italic') ? 'is-active' : ''}
        type="button"
      >
        italic silent
      </button>
      <button
        onClick={() => editor.chain().focus().toggleStrike().run()}
        className={editor.isActive('strike') ? 'is-active' : ''}
        type="button"
      >
        strike
      </button>
      <button
        onClick={() => editor.chain().focus().toggleCode().run()}
        className={editor.isActive('code') ? 'is-active' : ''}
        type="button"
      >
        code
      </button>
      <button onClick={() => editor.chain().focus().unsetAllMarks().run()} type="button">
        clear marks
      </button>
      <button onClick={() => editor.chain().focus().normalizeNodes().run()} type="button">
        clear nodes
      </button>
      <button
        onClick={() => editor.chain().focus().setParagraph().run()}
        className={editor.isActive('paragraph') ? 'is-active' : ''}
        type="button"
      >
        paragraph
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        className={editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}
        type="button"
      >
        h1
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        className={editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}
        type="button"
      >
        h2
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
        className={editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}
        type="button"
      >
        h3
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
        className={editor.isActive('heading', { level: 4 }) ? 'is-active' : ''}
        type="button"
      >
        h4
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()}
        className={editor.isActive('heading', { level: 5 }) ? 'is-active' : ''}
        type="button"
      >
        h5
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 6 }).run()}
        className={editor.isActive('heading', { level: 6 }) ? 'is-active' : ''}
        type="button"
      >
        h6
      </button>
      <button className={editor.isActive('link') ? 'is-active' : ''} type="button">
        link
      </button>
      <button
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={editor.isActive('bulletList') ? 'is-active' : ''}
        type="button"
      >
        bullet list
      </button>
      <button
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={editor.isActive('orderedList') ? 'is-active' : ''}
        type="button"
      >
        ordered list
      </button>
      <button
        onClick={() => editor.chain().focus().toggleCodeBlock().run()}
        className={editor.isActive('codeBlock') ? 'is-active' : ''}
        type="button"
      >
        code block
      </button>
      <button
        onClick={() => editor.chain().focus().toggleBlockquote().run()}
        className={editor.isActive('blockquote') ? 'is-active' : ''}
        type="button"
      >
        blockquote
      </button>
      <button onClick={() => editor.chain().focus().setHorizontalRule().run()} type="button">
        horizontal rule
      </button>
      <button onClick={() => editor.chain().focus().setHardBreak().run()} type="button">
        hard break
      </button>
      <button onClick={() => editor.chain().focus().undo().run()} type="button">
        undo
      </button>
      <button onClick={() => editor.chain().focus().redo().run()} type="button">
        redo
      </button>
    </div>
  );
};

export default Toolbar;
